import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IAuftrag } from "../types/Types";


/**
 * @author noone
 */

export type ParameterState = {
    linkuid: string | null,
    listAuftragWithStatus: string,
    googleToken: string | null,
    selectedAuftragIds: IAuftrag[],
}

const initialState = {
    linkuid: null,
    listAuftragWithStatus: "IN_TERMINIERUNG",
    googleToken: localStorage.getItem("calendarGoogleToken"),
    selectedAuftragIds: [],
} as ParameterState;

const allParameterSlice = createSlice({
    name: 'allParameter',
    initialState: initialState,
    reducers: {
        setLinkuid(state, action: PayloadAction<string>) {
            state.linkuid = action.payload;
        },
        setListAuftragWithStatus(state, action: PayloadAction<string>) {
            state.listAuftragWithStatus = action.payload;
        },
        setGoogleToken(state, action: PayloadAction<string>) {
            state.googleToken = action.payload;
            localStorage.setItem("calendarGoogleToken", action.payload);
        },
    }
});

export const {

    setLinkuid,
    setListAuftragWithStatus,
    setGoogleToken,

} = allParameterSlice.actions;

export default allParameterSlice;


